<div class="main-page-content container">
  <div class="main-page-content-block">

    <div class="row">
      <div class="col-12">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list"
                 [responsive]="true"
                 [paginator]="false"
                 [rows]="100"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 [lazy]="false"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped">

          <ng-template pTemplate="caption">
            <div class="d-flex justify-content-end">
              <div class="p-2 flex-fill"><h1 class="content-heading-font">On Demand Tasks</h1></div>
              <div class="ml-auto">
                <button class="btn btn-primary" (click)="loadTable()" title="Refresh">
                  <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
                </button>
              </div>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th class="text-center" style="width:70px;"></th>
              <th class="text-start">Task</th>
              <th class="text-center" style="width:100px;">Active</th>
              <th class="text-center" style="width:170px;">Requested</th>
              <th class="text-center" style="width:170px;">Start Running</th>
              <th class="text-center" style="width:170px;">Last Run</th>
              <th class="text-start">Last Result</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <th class="text-center">
                <button class="btn btn-sm btn-primary"
                        *ngIf="item.Active && !item.PendingRunID"
                        (click)="openRunDialog(item)"
                        title="Run On Demand Task">
                  <i class="pi pi-play"></i>
                </button>
                <button class="btn btn-sm btn-warning"
                        *ngIf="canCancelPendingRequest(item)"
                        (click)="cancelPendingRequest(item)"
                        title="Cancel Pending Request">
                  <i class="pi pi-times"></i>
                </button>
              </th>
              <td class="text-start">
                {{ item.Name }}
              </td>
              <td class="text-center">
                <span class="badge" [ngClass]="item.Active ? 'bg-success' : 'bg-secondary'">
                  {{ item.Active ? 'Active' : 'Disabled' }}
                </span>
              </td>
              <td class="text-center">
                <span *ngIf="item.PendingRequestedDate" class="badge bg-warning text-dark me-1">Pending</span>
                <span *ngIf="item.LastRequestedDate" title="{{ formatMountainTime(item.LastRequestedDate) }}">
                  {{ getTimeFromNow(item.LastRequestedDate) }}
                </span>
              </td>
              <td class="text-center">
                <span *ngIf="item.PendingStartRunningDate" class="badge bg-info text-dark me-1">Running</span>
                <span *ngIf="item.PendingStartRunningDate" title="{{ formatMountainTime(item.PendingStartRunningDate) }}">
                  {{ getTimeFromNow(item.PendingStartRunningDate) }}
                </span>
              </td>
              <td class="text-center">
                <span *ngIf="item.LastRunDate" title="{{ formatMountainTime(item.LastRunDate) }}">
                  {{ getTimeFromNow(item.LastRunDate) }}
                </span>
              </td>
              <td class="text-start">
                {{ item.LastRunResult }}
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">No items found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

  </div>
</div>

<p-dialog header="Run on demand task {{selectedTask?.Name}}" [modal]="true" [visible]="selectedTask!=null" styleClass="p-dialog-no-scroll" closable="false" resizable="false">
  <p class="pl-1 text-lg">
    Confirm that you want to run this on demand task.
  </p>

  <div class="row">
    <div class="col mb-3">
      <label for="params">Params</label>
      <input class="form-control" type="text" name="params" [(ngModel)]="params" required="required" />
    </div>
  </div>

  <div class="row">
    <div class="col text-center">
      <button class="btn btn-lg btn-primary" type="submit" id="btnRunOnDemandTask" [class.button-loading]="loading" (click)="runTask()">Confirm</button>
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnRunOnDemandTaskCancel" [class.button-loading]="loading" (click)="selectedTask=null">Cancel</button>
    </div>
  </div>
</p-dialog>
